import { useQuery } from "@apollo/client";
import { GET_CUSTOMER_REPORT } from "../apollo/queries";
import { getSelectedStoreDetails } from "../utils/helperFunctions";
import useFilters from "../core/hooks/useFilters";

const useCustomerReport = () => {
   const {search, debouncedValue, onChange, pagination, handlePageChange} = useFilters()
  const { loading, error, data } = useQuery(GET_CUSTOMER_REPORT, {
    variables: {
      input: {
        email: null,
        name: debouncedValue,
        limit: pagination.limit,
        pageStart: pagination.pageStart,
        store_id: getSelectedStoreDetails("id"),
      },
    },
    fetchPolicy: "network-only",
  });

  if (error) {
    console.log("Error While Getting Brands", error);
  }

  console.log("data", data)

  return {
    values: {
      customerReport: data?.customerReport || [],
      total: data?.customerReport?.total || 0,
      loading,
      search,
      pageValues: {
        current: pagination.pageStart + 1,
        pageSize: pagination.limit,
        total: data?.customerReport?.total || 0
      }
    },
    functions: {
      onChange,
      handlePageChange
    },
  };
};

export default useCustomerReport;
